import script from "./SAM2Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SAM2Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./SAM2Sidebar.vue?vue&type=style&index=0&id=51e40d0f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e40d0f"]])

export default __exports__